<script lang="ts" setup>
  import { computed, PropType } from "vue";
  import { darken, transparentize } from "color2k";

  import {
    conditionalContextMenuEntry,
    useContextMenu,
  } from "shared/utils/context-menu/use-context-menu";
  import { CalendarEvent } from "frontend/interfaces/calendar";

  const props = defineProps({
    event: {
      type: Object as PropType<CalendarEvent>,
      required: true,
    },
  });

  const eventStyle = computed(() => ({
    color: darken(props.event.color, 0.2),
    backgroundColor: transparentize(props.event.color, 0.8),
  }));

  const ctx = useContextMenu();
  if (props.event.ctxEditEvent)
    conditionalContextMenuEntry(ctx, props.event.ctxEditEvent);

  if (props.event.ctxDeleteEvent)
    conditionalContextMenuEntry(ctx, props.event.ctxDeleteEvent);
</script>

<template>
  <div
    class="calendar__event"
    v-bind:class="{
      'calendar__event--starts-before': event.startsBefore,
      'calendar__event--ends-after': event.endsAfter,
      'calendar__event--hoverable': event.ctxEditEvent || event.ctxDeleteEvent,
    }"
    v-bind:title="event.label"
    v-bind:style="eventStyle"
  >
    {{ event.label }}
  </div>
</template>

<style lang="scss" scoped>
  @use "shared/styles/colors";

  .calendar__event {
    pointer-events: auto;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding: 2px 5px;
    margin: 2px;
    min-width: 0;
    border-radius: 8px;
  }

  .calendar__event--starts-before {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  .calendar__event--ends-after {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  .calendar__event--hoverable:hover {
    outline: 3px solid colors.$color_calendar__unit--hover-on--outline;
  }
</style>
